import React from 'react';

import CommentSvg from 'assets/images/comment-icon.svg';

import BaseIcon from './BaseIcon';

const CommentIcon = props => <BaseIcon {...props} src={CommentSvg} />;

export default CommentIcon;
